import {
    SidebarGroup,
    SidebarGroupLabel,
    SidebarGroupContent,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarMenuSub,
    SidebarMenuSubButton,
} from '@duck/ui'
import { Link } from '@tanstack/react-router'
import { Users2, LayoutDashboard, Plus, Settings } from 'lucide-react'
import { useTar } from '@/modules/i18n/useTar'
import { useCohorts } from '@/hooks/useCohorts'
import { usePartnerTar } from '@/hooks/usePartnerTar'
import { useState } from 'react'
import { CreateCohortDialog } from '../PartnerCohorts/CreateCohortDialog'

type SideBarPartnerProps = {
    open: boolean
    handleMobileNav: () => void
}

export const SideBarPartner = ({ open, handleMobileNav }: SideBarPartnerProps) => {
    const { t } = useTar()
    const { tP: tPartner } = usePartnerTar()
    const { cohorts } = useCohorts()
    const [isCreateCohortDialogOpen, setIsCreateCohortDialogOpen] = useState(false)

    return (
        <>
            <SidebarGroup>
                <SidebarGroupLabel>{t('navigation.partnerArea')}</SidebarGroupLabel>
                <SidebarGroupContent>
                    <SidebarMenu>
                        <SidebarMenuItem>
                            {!open ? (
                                <SidebarMenuButton asChild>
                                    <Link to="/partner/dashboard" onClick={handleMobileNav}>
                                        <Users2 />
                                        <span>{t('navigation.partnerArea')}</span>
                                    </Link>
                                </SidebarMenuButton>
                            ) : (
                                <>
                                    <SidebarMenuButton asChild>
                                        <Link to="/partner/dashboard" onClick={handleMobileNav}>
                                            <LayoutDashboard />
                                            <span>{t('navigation.dashboard')}</span>
                                        </Link>
                                    </SidebarMenuButton>
                                    <SidebarMenuButton asChild>
                                        <Link to="/partner/settings" onClick={handleMobileNav}>
                                            <Settings />
                                            <span>{t('navigation.settings')}</span>
                                        </Link>
                                    </SidebarMenuButton>
                                    <SidebarMenuButton asChild>
                                        <div className="pointer-events-none">
                                            <Users2 />
                                            <span>{tPartner('cohorts')}</span>
                                        </div>
                                    </SidebarMenuButton>
                                    <SidebarMenuSub>
                                        {[...cohorts]
                                            .sort((a, b) => {
                                                if (a.isActive === b.isActive) return 0
                                                return a.isActive ? -1 : 1
                                            })
                                            .map((cohort) => (
                                                <SidebarMenuSubButton key={cohort.id} asChild>
                                                    <Link
                                                        to="/partner/c/$id"
                                                        params={{ id: cohort.id }}
                                                        preload="intent"
                                                        onClick={handleMobileNav}
                                                    >
                                                        <Users2 />
                                                        <span>
                                                            {cohort.name}
                                                            {!cohort.isActive && (
                                                                <span className="text-muted-foreground"> ({t('partner.closed')})</span>
                                                            )}
                                                        </span>
                                                    </Link>
                                                </SidebarMenuSubButton>
                                            ))}
                                        <SidebarMenuSubButton
                                            onClick={(e) => {
                                                e.preventDefault()
                                                setIsCreateCohortDialogOpen(true)
                                            }}
                                        >
                                            <Plus />
                                            <span>{tPartner('newCohort')}</span>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSub>
                                </>
                            )}
                        </SidebarMenuItem>
                    </SidebarMenu>
                </SidebarGroupContent>
            </SidebarGroup>
            <CreateCohortDialog
                isOpen={isCreateCohortDialogOpen}
                onClose={() => setIsCreateCohortDialogOpen(false)}
            />
        </>
    )
}
